/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import _ from 'lodash';

import { RootState } from '@ibm-watson/shared/ts/state';
import { isAws } from '../../../ia/util/config';

export const selectContactCenterConnectionStatus = (state: RootState) =>
  state.integrations?.phone?.contact_center?.status;

export const selectContactCenterProvider = (state: RootState) =>
  state.integrations?.phone?.contact_center?.provider;

export const selectIntelepeerStatus = (state: RootState) =>
  state.integrations?.phone?.intelepeer?.status;

export const selectIntelepeerState = (state: RootState) =>
  state.integrations?.phone?.intelepeer?.state;

export const selectPhoneIntegrationType = (state: RootState) =>
  state.integrations?.draftIntegration?.integration?.settings?.contact_center
    ?.provider;

export const selectSTTInstanceCreateRequired = (state: RootState) =>
  state.integrations?.phone?.stt_instance_create_required;

export const selectTTSInstanceCreateRequired = (state: RootState) =>
  state.integrations?.phone?.tts_instance_create_required;

export const selectPhoneGatewaySecret = (state: RootState) =>
  _.get(
    state.integrations?.draftIntegration?.integration?.settings,
    'private.secrets.voice_gateway_origin_key'
  );

export const selectPhoneGatewayWebhookURL = (state: RootState) =>
  _.get(
    state.integrations?.draftIntegration?.integration?.settings,
    'private.secrets.voice_gateway_webhook_url'
  );

export const selectTextToSpeechPitchPercentage = (state: RootState) =>
  _.get(
    state.integrations?.draftIntegration?.integration?.settings,
    'text_to_speech.config.pitch_percentage'
  );

export const selectTextToSpeechRatePercentage = (state: RootState) =>
  _.get(
    state.integrations?.draftIntegration?.integration?.settings,
    'text_to_speech.config.rate_percentage'
  );

/**
 * In AWS, we do not want the Phone TTS/STT tabs to show the instance picker for
 * TTS/STT instances
 */
export const shouldHideInstancePicker = (): boolean => isAws;
